// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__OwHNb","modalForm":"UpgradeEpcsModal_modalForm__Ilcl6","modalFooter":"UpgradeEpcsModal_modalFooter__3NvrH"};